import React from 'react';
import PropTypes from 'prop-types';
import { Nav, Row, Col } from 'react-bootstrap';
import NavbarNavLink from './NavbarNavLink';

function NavbarDropdownSection({ sections }) {
  return sections && sections.length && (
    <Row sm={12} md={sections.length}>
      {sections.filter((section) => section.children && !!section.children.length)
        .map((section) => (
          <Col key={section.name}>
            <Nav className="flex-column">
              <NavbarNavLink title={section.label} />
              {section.children.map((route) => (
                <NavbarNavLink key={route.name} route={route} />
              ))}
            </Nav>
          </Col>
        ))}

    </Row>
  );
}

NavbarDropdownSection.propTypes = {
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      chlidren: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        resource: PropTypes.string.isRequired,
      })),
    }).isRequired,
  ).isRequired,
};

export default NavbarDropdownSection;
